import React from 'react';
import { insertAtLineStart } from '../utils/InsertTextAtPosition';
import { jsx as _jsx } from "react/jsx-runtime";
export var title4 = {
  name: 'title4',
  keyCommand: 'title4',
  shortcuts: 'ctrlcmd+4',
  value: 'title4',
  buttonProps: {
    'aria-label': 'Insert title4 (ctrl + 4)',
    title: 'Insert title4 (ctrl + 4)'
  },
  icon: /*#__PURE__*/_jsx("div", {
    style: {
      fontSize: 14,
      textAlign: 'left'
    },
    children: "Title 4"
  }),
  execute: (state, api) => {
    if (state.selection.start === 0 || /\n$/.test(state.text)) {
      api.replaceSelection('#### ');
    } else {
      insertAtLineStart('#### ', state.selection.start, api.textArea);
    }
  }
};